export const sum = (values: number[]): number =>
  values.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
